import { Button } from '../../../ui';

const PHONE_NUMBER = '+37444224226';

const Hero = () => {
  const handleScrollToOffer = () => {
    const section = document.getElementById('offer');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleCall = () => {
    window.location.href = `tel:${PHONE_NUMBER}`;
  };

  return (
    <section className="relative overflow-hidden bg-black">
      <video
        src="/images/smartTvAdvertising/hero-bg-mobile.mp4"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="absolute inset-0 block object-cover object-center w-full h-full md:hidden"
      />
      <video
        src="/images/smartTvAdvertising/hero-bg.mp4"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="absolute inset-0 hidden object-cover object-right w-full h-full md:block lg:object-center"
      />
      <div className="container relative z-10 flex flex-col justify-end min-h-[80vh] md:min-h-[804px] pt-[64px] pb-[32px] md:pb-[64px] lg:pb-[128px]">
        <h1 className="font-[700] text-[64px] md:text-[128px] leading-[0.9] text-white mb-[24px] md:mb-[32px]">
          CTV <span className="text-[48px] md:text-[72px] md:ml-[-24px]">գովազդ</span>
        </h1>
        <div className="flex gap-[16px] flex-col md:flex-row">
          <Button
            variant="lightGreenOffer"
            className="!text-[16px] md:!text-[18px] md:w-[230px] w-full hover:md:w-[210px]"
            onClick={handleScrollToOffer}
          >
            Ստանալ առաջարկ
          </Button>
          <Button variant="whiteOffer" className="!text-[16px] md:!text-[18px] md:w-[380px] w-full hover:md:w-[360px]" onClick={handleCall}>
            Խոսել վաճառքի մասնագետի հետ
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
